import * as Yup from "yup";
import checkout from "./form3";

const {
  formField3: {
    allocationActivity,
    quarter,
    year,
    firstTime,
    supplementaryForThe,
    taxpayerName,
    taxId,
  },
} = checkout;

const validation3 = Yup.object().shape({
  [allocationActivity.name]: Yup.string().required(allocationActivity.errorMsg),
  [firstTime.name]: Yup.string().required(firstTime.errorMsg),
  [supplementaryForThe.name]: Yup.string()
    .matches(/^\d+$/, supplementaryForThe.invalidMsg)
    .required(supplementaryForThe.errorMsg),
  [quarter.name]: Yup.number().required(quarter.errorMsg),
  [year.name]: Yup.number().required(year.errorMsg),
  [taxId.name]: Yup.string()
    .matches(/^\d{10}(?:-\d{3})?$/, taxId.invalidMsg)
    .required(taxId.errorMsg),
  [taxpayerName.name]: Yup.string().required(taxpayerName.errorMsg),
});

export default validation3;
